import React, {useEffect, useState, useRef}  from "react";
import ScholarshipService from "../services/ScholarshipService"
import Filter from "./Filter";
import FilterButton from "./FilterButton";
import FilterButtonMore from "./FilterButtonMore";
import { useTranslation } from 'react-i18next';

const createInitialFilters = () => ({
    faculties: [],
    nations: [],
    counties: [],
    kinship: [],
    qualifications: [],
    levels: [],
    travel: [],
    otherUniversities: [],
    general: [],
    searchInput: ''
});

export default function Search(props) {
    const { t, i18n } = useTranslation();
    const { filterMethod } = props;

    const [faculties, setFaculties] = useState([]);
    const [nations, setNations] = useState([]);
    const [counties, setCounties] = useState([]);
    const [kinship, setKinship] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [levels, setLevels] = useState([]);
    const [showMoreFilters, setShowMoreFilters] = useState(true);

    const childComponentRef = useRef({});
    const filterMethodRef = useRef(filterMethod);

    const [Filters, setFilters] = useState(createInitialFilters)

    useEffect(() => {
        filterMethodRef.current = filterMethod;
    }, [filterMethod]);

    useEffect(()=>{
        const resetFilters = createInitialFilters();
        setFilters(resetFilters);
        filterMethodRef.current(resetFilters);

        getFaculties(i18n.resolvedLanguage);
        getNations();
        getCounties(i18n.resolvedLanguage);
        getKinship(i18n.resolvedLanguage);
        getQualifications(i18n.resolvedLanguage);
        setLevels({ 1: i18n.t('filter.level.basic_advanced'), 2: i18n.t('filter.level.doctorial') })
        toggleMoreFilters()
    }, [i18n, i18n.resolvedLanguage])
    
    const getFaculties = (lang) => {
        ScholarshipService.getFaculties(lang)
        .then(response => {
            setFaculties(response.data);
        })
        .catch(e => {
            console.log(e);
        });
    }

    const getNations = () => {
        ScholarshipService.getNations()
        .then(response => {
            setNations(response.data);
        })
        .catch(e => {
            console.log(e);
        });
    }

    const getCounties = (lang) => {
        ScholarshipService.getCounties(lang)
        .then(response => {
            setCounties(response.data);
        })
        .catch(e => {
            console.log(e);
        });
    }

    const getKinship = (lang) => {
        ScholarshipService.getKinship(lang)
        .then(response => {
            setKinship(response.data);
        })
        .catch(e => {
            console.log(e);
        });
    }

    const getQualifications = (lang) => {
        ScholarshipService.getSpecificQualifications(lang)
        .then(response => {
            setQualifications(response.data);
        })
        .catch(e => {
            console.log(e);
        });
    }

    const handleFilters = (filters, category) => {
        const newFilters = { ...Filters }
        newFilters[category] = filters

        setFilters(newFilters)
        filterMethod(newFilters);
    }

    const removeFilter = ( value, category ) => {
        if(category === 'travel' || category === 'otherUniversities' || category === 'general') {
            const filter = Filters[category];
            const currentIndex = filter.indexOf(value)
       
            if (currentIndex !== -1) {
                filter.splice(currentIndex, 1)
                handleFilters(filter, category)
            }
        } else {
            //Calls method in child component to remove filter and uncheck checkbox.
            childComponentRef.current[category].removeFilterCheckbox(value)
        }
    }

    const closeOtherFilters = () => {
        let element = document.querySelector('.search-filters div.show');
        if (element !== null) {
            element.classList.remove('show')
        }

        let activeButton = document.querySelector('.filter-container button[aria-expanded="true"]:not(#buttonShowMoreLess)')
        if (activeButton !== null) {
            activeButton.setAttribute('aria-expanded', 'false');
        }
    }

    /**
     * Metoden är kopierad från Designsystemet (theme-uu.js, version 6.0) då jag inte fick deras lösning att fungera.
     */
    const toggleMoreFilters = () => {
        const uuToggles = document.querySelectorAll('[data-uu-toggle]');
        uuToggles.forEach(function(toggle) {
            const target = toggle.dataset.uuToggle;
            const closeExpanded = toggle.dataset.uuToggleCloseExpanded === 'true';
            toggle.addEventListener('click', function() {
                const targets = document.querySelectorAll('[data-uu-target="' + target + '"]');
                targets.forEach(function(target) {
                    target.classList.toggle('d-none');
                    if (closeExpanded && target.ariaExpanded === 'true') {
                        // Close expanded element, let bootstrap handle it
                        target.click();
                    }
                });
                
                toggle.ariaExpanded = toggle.ariaExpanded === 'true' ? 'false' : 'true';
            });
        });
    }

    return (
        <div className="search-list">
            <div className="search-form flex-sm-column">
                <label htmlFor="mySearchFilter " className="visually-hidden ">{(t('search.label_search_filter'))}</label>
                <input className="search-form-input " type="search " id="mySearchFilter " autoComplete="off " name="q" value={Filters.searchInput} onChange={(e) => handleFilters(e.target.value, "searchInput")}/>
            </div>
            <div className="search-filters-selected ">
                <p className="visually-hidden ">{(t('search.selected_filter'))}</p>
                { Object.keys(Filters).map(key => {
                    return key !== "searchInput" && Filters[key].length > 0 && Filters[key].map((value, index) => (
                        <button className="button-text button-icon icon-clear search-filter-selected " id={`${key}-${index}`} key={`${key}-${index}`}
                                onClick={() => removeFilter(value, key)}>{value} <span className="visually-hidden ">{(t('search.remove_filter'))}</span></button>
                ))})}
            </div>
            <div className="button-group search-filters" id="accordion">
                <div className="filter-container">
                    <FilterButton key="filterButton-level" type="level" buttonName={t('search.filter_button.level')} nrOfCheckedCheckboxes={Filters.levels.length} />
                    <Filter key={`filter-level-${i18n.resolvedLanguage}`} ref={ref => { childComponentRef.current['levels'] = ref; }} type="level" list={levels} handleFilters={filters => handleFilters(filters, "levels")}/>

                    <FilterButton key="filterButton-faculty" type="faculty" buttonName={t('search.filter_button.faculty')} nrOfCheckedCheckboxes={Filters.faculties.length} />
                    <Filter key={`filter-faculty-${i18n.resolvedLanguage}`}  ref={ref => { childComponentRef.current['faculties'] = ref; }} type="faculty" list={faculties} handleFilters={filters => handleFilters(filters, "faculties")}/>

                    <FilterButton key="filterButton-nation" type="nation" buttonName={t('search.filter_button.nation')} nrOfCheckedCheckboxes={Filters.nations.length} />
                    <Filter key={`filter-nation-${i18n.resolvedLanguage}`} ref={ref => { childComponentRef.current['nations'] = ref; }} type="nation" list={nations} handleFilters={filters => handleFilters(filters, "nations")}/>
                    
                    <button id="filterButton-general" title={t('search.tooltip.general')} className={`button-filter collapsed ${Filters.general.length === 0 ? '' : 'button-icon icon-filter icon-badge'}`}
                            data-badge-number={Filters.general.length === 0 ? '' : '1'}
                            onClick={() => {handleFilters((Filters.general.length === 0 ? [t('search.filter_button.general')] : []), 'general'); closeOtherFilters();}}>
                        <span className="visually-hidden">{t('search.filter_on')} </span>{t('search.filter_button.general_name')}
                    </button>
                   
                    <button id="buttonShowMoreLess" onClick={() => {setShowMoreFilters(!showMoreFilters); closeOtherFilters();}}  className="button-text button-toggle-filters" data-uu-toggle="more-filters" data-uu-toggle-close-expanded="true" aria-controls="filterButton-travel filterButton-kinship filterButton-qualification filterButton-otherUniversities filterButton-general" aria-expanded="false">
                        <span> { showMoreFilters ? t('search.filter_button.show_less') : t('search.filter_button.show_more')}</span>
                    </button>
                    <button id="filterButton-travel" className={`button-filter collapsed ${showMoreFilters ? '' : 'd-none'} ${Filters.travel.length === 0 ? '' : 'button-icon icon-filter icon-badge'}`}
                            data-badge-number={Filters.travel.length === 0 ? '' : '1'}
                            data-uu-target="more-filters"
                            onClick={() => {handleFilters((Filters.travel.length === 0 ? [t('scholarship.categories.travel')] : []), 'travel'); closeOtherFilters();}}>
                        <span className="visually-hidden">{t('search.filter_on')} </span>{t('search.filter_button.travel')}
                    </button>
                    <FilterButtonMore key="filterButton-county" type="county" buttonName={t('search.filter_button.geographical_connection')} nrOfCheckedCheckboxes={Filters.counties.length} showMoreFilters={showMoreFilters}/>
                    <Filter key={`filter-county-${i18n.resolvedLanguage}`} ref={ref => { childComponentRef.current['counties'] = ref; }} type="county" list={counties} handleFilters={filters => handleFilters(filters, "counties")}/>
                    <FilterButtonMore key="filterButton-kinship" type="kinship" buttonName={t('search.filter_button.kinship')} nrOfCheckedCheckboxes={Filters.kinship.length} showMoreFilters={showMoreFilters}/>
                    <Filter key={`filter-kinship-${i18n.resolvedLanguage}`} ref={ref => { childComponentRef.current['kinship'] = ref; }} type="kinship" list={kinship} handleFilters={filters => handleFilters(filters, "kinship")}/>
                    <FilterButtonMore key="filterButton-qualification" type="qualification" buttonName={t('search.filter_button.specific_qualification')} nrOfCheckedCheckboxes={Filters.qualifications.length} showMoreFilters={showMoreFilters}/>
                    <Filter key={`filter-qualification-${i18n.resolvedLanguage}`} ref={ref => { childComponentRef.current['qualifications'] = ref; }} type="qualification" list={qualifications} handleFilters={filters => handleFilters(filters, "qualifications")}/>
                    <button id="filterButton-otherUniversities" className={`button-filter collapsed ${showMoreFilters ? '' : 'd-none'} ${Filters.otherUniversities.length === 0 ? '' : 'button-icon icon-filter icon-badge'}`}
                            data-badge-number={Filters.otherUniversities.length === 0 ? '' : '1'}
                            data-uu-target="more-filters"
                            onClick={() => {handleFilters((Filters.otherUniversities.length === 0 ? [t('search.filter_button.other_universities')] : []), 'otherUniversities'); closeOtherFilters();}}>
                        <span className="visually-hidden">{t('search.filter_on')} </span>{t('search.filter_button.other_universities')}
                    </button>
                </div>
            </div>
        </div>
    );
}
